import { useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'

export const IssuerRoutes = () => {
  const User = useSelector(state => state.User)
  let isIssuer = User.user_type == 'Issuer' || User.user_type=="Super Admin"
  return (
    isIssuer ? <Outlet /> : <Navigate to='/Error/' />
  )
}